import { Injectable } from '@angular/core';

import {
  ApexAxisChartSeries,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexChart,
  ApexPlotOptions,
  ApexFill,
  ApexGrid,
  ApexXAxis,
  ApexYAxis,
  ApexTheme,
  ApexLegend
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  title: ApexTitleSubtitle;
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  grid: ApexGrid;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  theme: ApexTheme;
  legend: ApexLegend;
};

@Injectable({
  providedIn: 'root'
})
export class HeatMapsService {

  public chartOptions: Partial<ChartOptions>;


  constructor() { this.initChartOptions(); }

  initChartOptions() {

    this.chartOptions = {
      series: [],
      chart: {
        height: 350,
        type: "heatmap"
      },
      plotOptions: {
        heatmap: {
          shadeIntensity: 0.5,
          radius: 0,
          useFillColorAsStroke: true,
          colorScale: {
            ranges: [
              {
                from: 0,
                to: 0,
                name: "Bajo",
                // color: "#04a98e40"
                color: "#04a98d"
              },
             /* {
                from: 51,
                to: 100,
                name: "Medio",
                // color: "#04a98e80"
                color: "#04a98d"
              },
               {
                from: 51,
                to: 75,
                name: "Alto",
                // color: "#04a98ebf"
                color: "#04a98d"
              },
              {
                from: 76,
                to: 100,
                name: "Muy alto",
                // color: "#04a98d"
                color: "#04a98d"
              }*/
            ]
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      title: {},
      grid: {},
      yaxis: {},
      xaxis: {},
      legend: {
        show: false,
      },
      theme: {},

    };
  }

}
